export default __webpack_public_path__ + "static/media/no_chat.7131e3cf.svg";